"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function btc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.6222 10.5341C17.8577 8.9621 16.6599 8.11685 15.0234 7.55285L15.5544 5.42285L14.2584 5.10035L13.7409 7.1741C13.4004 7.0886 13.0509 7.0091 12.7022 6.9296L13.2234 4.84235L11.9274 4.5191L11.3964 6.64835C11.1144 6.58385 10.8369 6.52085 10.5684 6.45335L10.5699 6.4466L8.78193 6.00035L8.43693 7.38485C8.43693 7.38485 9.39918 7.60535 9.37893 7.61885C9.90393 7.7501 9.99843 8.09735 9.98268 8.37335L9.37818 10.7996C9.41418 10.8086 9.46068 10.8221 9.51318 10.8424L9.37593 10.8086L8.52843 14.2076C8.46393 14.3666 8.30118 14.6059 7.93368 14.5151C7.94718 14.5339 6.99168 14.2804 6.99168 14.2804L6.34818 15.7639L8.03568 16.1846C8.34918 16.2634 8.65668 16.3459 8.95893 16.4231L8.42268 18.5771L9.71793 18.8996L10.2489 16.7696C10.6029 16.8649 10.9464 16.9534 11.2824 17.0374L10.7529 19.1584L12.0489 19.4809L12.5852 17.3314C14.7962 17.7499 16.4582 17.5811 17.1579 15.5816C17.7219 13.9721 17.1302 13.0429 15.9669 12.4376C16.8144 12.2426 17.4519 11.6854 17.6222 10.5341ZM14.6597 14.6876C14.2599 16.2979 11.5487 15.4271 10.6697 15.2089L11.3822 12.3551C12.2612 12.5749 15.0789 13.0091 14.6597 14.6876ZM15.0609 10.5109C14.6957 11.9756 12.4397 11.2309 11.7084 11.0486L12.3534 8.4611C13.0847 8.64335 15.4419 8.9831 15.0609 10.5109Z", fill: color }));
}
exports["default"] = btc;
//# sourceMappingURL=btc.js.map